import React from 'react'
import CanadaTemplateDefault from 'src/components/template/ca/'
import { canadaPlanSet } from 'src/constants/planData/canadaPlanData'
import { videos } from 'src/constants/videos'
import { useCohortFlag } from 'src/modules/hooks/useCohortFlag'
import { WEB_MARKETING_CA_VALUE_PROPS } from 'src/modules/reducers/cohorts/constants'
import styled from 'styled-components'

export default (props) => {
  const showValueProps = useCohortFlag(WEB_MARKETING_CA_VALUE_PROPS)
  const valuePropsCopy = ['Unlimited Cloud DVR', 'Cancel Anytime', 'Every EPL Match']
  return (
    <StyledContainer>
      <CanadaTemplateDefault
        location={props.location}
        lang="en"
        market="canada"
        video={videos.seasonal_ca.videoUrl}
        videoMobile={videos.seasonal_ca.videoMobileUrl}
        annotations={videos.seasonal_ca.annotations}
        title="Watch live sports & entertainment"
        subtitle={
          <>
            {' '}
            Enjoy top leagues, <span className="mobile-line-break"> popular TV shows & more </span>
          </>
        }
        networkSet="canadaEssentials"
        hasPlanCardsTabs={true}
        valuePropsCopy={showValueProps ? valuePropsCopy : null}
        planCardsConfig={{
          plans: canadaPlanSet.sports,
        }}
      />
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  .content-container .hero-content {
  }
`
